// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbLink":"breadcrumb_breadCrumbLink__RzYMG","breadCrumbText":"breadcrumb_breadCrumbText__ta1AJ","breadCrumb":"breadcrumb_breadCrumb__HA06S"};